<script>
  export default {
    name: 'Panel',
    props: {
      tag: {
        default: 'div',
      },
    },
    render (el) {
      return el(this.tag, {
        class: 'panel',
      }, [
        el('header', {}, [
          this.$slots.header
        ]),
        this.$slots.default,
      ]);
    }
  }
</script>

<style lang="scss">
  @mixin panel-width($percent) {
    flex-basis: $percent;
    flex-basis: calc(#{$percent} - #{2*$panel-margin});
  }

  .panel {
    @include panel-shadow();
    flex-grow: 1;
    margin: $panel-margin;
    @media (max-width: $max-sm) {
      width: calc(100% - #{2*$panel-margin}) !important;
      flex-grow: 1 !important;
    }
    @media (max-width: $xxs-max) {
      margin: 10px;
      width: calc(100% - 20px) !important;
    }
    &, > header:empty + a:last-child {
      padding: $panel-margin;
      @media (min-width: $min-lg) {
        padding: 28px 65px;
      }
    }
    > header:empty + a:last-child {
      display: block;
      //margin: -28px #{-35px};
      margin: -$panel-margin;
      @media (min-width: $min-lg) {
        margin: -28px #{-65px};
      }
      @media (max-width: $max-xs) {
        //margin: -28px #{-25px};
      }
    }
    .inside {
      max-width: 1100px + 2*$panel-margin;
      margin: 0 auto;
      text-align: center;
    }
    background: $default-bg;
    &.state-error {
      background: mix($default-bg, $state-error, 90%);
      color: $state-error;
    }
    &.state-warning {
      background: mix($default-bg, $state-warning, 90%);
      color: $accent;
    }
    &.state-success {
      background: mix($default-bg, $state-success, 90%);
      color: $state-success;
    }
    border-top: solid 5px $default-border;
    flex-grow: 1;
    flex-shrink: 1;
    position: relative;
    &.holder {
      padding-left: $gutter;
      padding-right: $gutter;
    }
    @include panel-width(100%);
    &.third {
      @media (min-width: $min-md) {
        @include panel-width(50%);
      }
      @media (min-width: $min-lg) {
        @include panel-width(33.333%);
      }
    }
    &.third-keep {
      @media (min-width: $min-md) {
        @include panel-width(33.333%);
      }
    }
    &.half {
      @media (min-width: $min-lg) {
        @include panel-width(50%);
      }
    }
    &.half-keep {
      @media (min-width: $min-md) {
        @include panel-width(50%);
      }
    }
    &.two-thirds {
      @media (min-width: $min-lg) {
        @include panel-width(66.666%);
      }
      @media (max-width: $max-md) {
        + .panel.third {
          @include panel-width(100%);
        }
        + .panel.third-keep {
          @include panel-width(50%);
        }
      }
    }
    &.two-thirds-keep {
      @media (min-width: $min-md) {
        @include panel-width(66.666%);
      }
      @media (max-width: $max-md) {
        & + .panel.third {
          @include panel-width(100%);
        }
      }
    }
    &.third, &.two-thirds, &.half,
    &.third-keep, &.two-thirds-keep, &.half-keep {
      flex-grow: 0;
      flex-shrink: 0;
      overflow: hidden;
    }
    .panel {
      border-top: none;
      padding: 22px 10px;
      @include panel-shadow(rgba(black, .15), 3px);
      @media (max-width: $xs-max) {
        margin-left: -10px;
        margin-right: -10px;
      }
    }
    .close {
      @extend %close-icon;
      background-color: $accent;
      @media print {
        display: none;
      }
    }
    > header {
      @include clearfix();
      padding: 0 0 27px;
      text-align: center;
      &:not(:first-child) {
        padding-top: 27px;
      }
      &:empty {
        display: none;
        + header {
          padding-top: 0;
        }
      }
      h1, h2, h3, h4, h5 {
        @include font-size(22px);
        &:first-child {
          margin-top: 0;
        }
      }
      &:not(.center) > :not(:only-child) {
        @media (max-width: $xs-min - 1px) {
          text-align: left;
          &:empty {
            display: none;
          }
        }
        @media (min-width: $xs-min) {
          float: right;
          &:first-child {
            float: left;
          }
        }
      }
    }

    &.submenu {
      margin-top: 0;
      margin-left: 0;
      margin-bottom: 0;
      padding: 40px 0 0;
      min-height: calc(100vh - #{$breadcrumbs-height});
      flex-basis: $submenu-width;
      flex-grow: 0;
      flex-shrink: 0;
      @include paint_menu($default-bg, $default-color, darken($default-bg, 20%), $default-color, $accent);
      nav.menu {
        @extend %sidemenu;
      }
      + * {
        align-self: flex-start;
      }
      > header {
        text-align: left;
        @media (max-width: $md-max) {
          text-align: center;
        }
        padding-left: 17px;
      }
      @media (max-width: $md-max) {
        flex-basis: 100%;
        min-height: 0;
        padding-top: 20px;
        text-align: center;
        @media (min-width: $sm-min) {
          nav.menu {
            > span {
              display: inline-block;
              > a {
                border: none;
                padding-left: 12px;
                padding-right: 12px;
              }
            }
          }
        }
      }
    }
  }
  .wizard .panel {
    @include panel-shadow(rgba(black, .15), 3px);
  }
</style>



// WEBPACK FOOTER //
// src/helpers/components/panels/Panel.vue